import { ReactElement } from 'react';
import { useRoutes, useAwsGetter, buildRoute } from '@localstack/services';
import { useParams } from 'react-router-dom';
import { Card, CardContent } from '@mui/material';
import { LambdaCapacityProviderVersionsTable, PageTitle } from '@localstack/ui';
import { DEFAULT_LAMBDA_ROUTES } from '@localstack/constants';

import { LambdaProps } from './types';

export const LambdaCapacityProviderFunctionVersions = ({
  Layout,
  clientOverrides,
  routes = DEFAULT_LAMBDA_ROUTES,
}: LambdaProps): ReactElement => {
  const { goto } = useRoutes();
  const { name } = useParams<'name'>();

  const { data: versions, isLoading: isVersionsLoading } = useAwsGetter(
    'Lambda',
    'listFunctionVersionsByCapacityProvider',
    [{ CapacityProviderName: name }],
    { clientOverrides },
  );

  return (
    <Layout
      documentTitle="Lambda: Capacity Provider Function Versions"
      title={
        <PageTitle
          title="Capacity Provider Function Versions"
          breadcrumbs={[
            ['Lambda', () => goto(routes.RESOURCES_LAMBDA)],
            ['Capacity Providers', () => goto(routes.RESOURCES_LAMBDA_CAPACITY_PROVIDERS)],
            [name, () => goto(routes.RESOURCES_LAMBDA_CAPACITY_PROVIDER, { name })],
            ['Function Versions', () => null],
          ]}
        />
      }
    >
      <Card>
        <CardContent>
          <LambdaCapacityProviderVersionsTable
            data={versions?.FunctionVersions ?? []}
            loading={isVersionsLoading}
            onView={(arn) => {
              const functionNameWithVersion = arn.split(':').slice(-2).join(':');
              // example: my-function:1 OR my-function:$LATEST
              window
                .open(buildRoute(routes.RESOURCES_LAMBDA_FUNCTION, { name: functionNameWithVersion }), '_blank')
                ?.focus();
            }}
          />
        </CardContent>
      </Card>
    </Layout>
  );
};
